import React, { useState } from 'react';
import { useT } from '../i18n';
import { saveGuestDesign } from '../utils/guestDesign';
import GuestRegisterModal from './GuestRegisterModal';
import './GuestSaveButton.css';

// Replaces the cloud "Saved"/"Saving" status pill everywhere it appears
// (Builder, FloorPlan, RoomEditor, House3DView) while in the unauthenticated
// "/try" flow. There's nothing to autosave to yet, so this snapshots the
// current design into localStorage and opens the sign-up modal in place —
// GuestRegisterModal picks the snapshot back up once the account exists.
export default function GuestSaveButton({ className = '' }) {
  const { t } = useT();
  const [showModal, setShowModal] = useState(false);

  function handleClick() {
    saveGuestDesign();
    setShowModal(true);
  }

  return (
    <>
      <button className={`guest-save-btn ${className}`} onClick={handleClick} title={t('guest_save_tooltip')}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <rect x="1.5" y="1.5" width="11" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
          <rect x="3.5" y="1.5" width="5" height="4" rx="0.5" stroke="currentColor" strokeWidth="1.3"/>
          <rect x="3" y="7" width="8" height="4.5" rx="0.8" stroke="currentColor" strokeWidth="1.3"/>
        </svg>
        {t('save')}
      </button>
      {showModal && <GuestRegisterModal onClose={() => setShowModal(false)} />}
    </>
  );
}
